<template>
  <body>
    <div style="width: 100%; background-color: rgba(0, 0, 0, 0)">
      <img
        style="
          height: 100vh;
          width: 100vw;
          overflow: hidden;
          position: absolute;
        "
        :src="require(`@/assets/RegisterNew/bgp0${randomPic}.jpg`)"
      />
      <span id="actionFrameId">
        <!--注册操作框，流程2,实名认证-->
      <div v-if="registerStep == 1" class="actionFrame">
        <div class="logo">
          <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
        </div>
        <div class="titleCtn">
          <div class="title-1">创建实名认证账户</div>
        </div>
        <div @click="whyIdentifyTip = true" class="text3-ctn">
          为什么要实名认证
          <img src="../assets/RegisterNew/为什么-默认.png" style="margin-bottom: -1px" height="12" width="12"/>
          <div v-if="whyIdentifyTip" style="position: absolute; left: 105px; top: -65px">
              <img @click.stop="whyIdentifyTip = false" src="../assets/RegisterNew/实名提示.png" width="321"/>
              <img @click.stop="whyIdentifyTip = false" style="position: absolute; top: 5px; right: 5px" src="../assets/RegisterNew/关闭提示内容.png" height="16" width="16"/>
            </div>
        </div>
        <!--手机号-->
        <div class="input-ctn" style="margin-top: 48px">
          <v-text-field
                  v-model="telephone"
                  label="手机号"
                  placeholder="请输入手机号"
                  outlined
                  readonly
                  disabled
          >
            <template v-slot:prepend-inner>
              <div
                      style="
                  width: 35px;
                  padding-top: 3px;
                  padding-bottom: 2px;
                  border-right: solid 1px rgba(0, 0, 0, 0.25);
                  color: rgba(0, 0, 0, 0.35);
                "
              >
                +86
              </div>
            </template>
          </v-text-field>
        </div>
        <!--真实姓名-->
        <div class="input-ctn" style="margin-top: 15px">
          <v-text-field
                  v-model="realName"
                  label="真实姓名"
                  placeholder="请输入真实姓名"
                  outlined
                  key="123"
          >
          </v-text-field>
        </div>
        <!--身份证号-->
        <div class="input-ctn" style="margin-top: 15px">
          <v-text-field
                  v-model="IDCard"
                  label="身份证号码"
                  placeholder="请输入身份证号码"
                  outlined
                  @blur="ifCanIdentify"
          >
          </v-text-field>
          <!--<div style="margin-top:-20px;">-->
            <!--<v-icon size="14" color="rgba(0,0,0,0.3)">info</v-icon>-->
            <!--<span style="font-size:12px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;  color: #979797;">我们仅通过支付宝认证您的真实信息，但不会记录您的身份证信息</span>-->
          <!--</div>-->
        </div>
        <!--身份证，认证解释-->
        <div class="input-ctn" style="height: 16px;line-height: 16px;font-size: 12px;color:#979797;margin-top: 7px;padding-left: 3px;">
           <v-icon size="14" color="rgba(0,0,0,0.3)">info</v-icon> 我们仅通过支付宝认证您的真实信息，但不会记录您的身份证信息
        </div>
        <!--点击实名认证-->
        <div :class="certificationAllow ? 'operateButton' : 'operateButton_disabled'"
             @click="clickCertification"
             style="margin-top: 35px"
        >
          支付宝实名认证
        </div>
        <!--底部文字-->
        <div class="text2-ctn" style="font-size: 14px">
          Copyright © 2023-2025 长光卫星技术股份有限公司
          <a
                  target="_blank"
                  href="/PrivacyPolicy"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 隐私政策
          </a>
          <a
                  target="_blank"
                  href="/ServiceAgreement"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 服务协议</a
          >
        </div>
        <!--错误提示-->
        <div v-if="showAlert" class="alertCtn">
          {{ alertTip }}
          <img
                  class="closeAlert"
                  @click="showAlert = false"
                  src="../assets/RegisterNew/关闭提示内容.png"
                  height="22"
                  width="22"
          />
        </div>
      </div>
        <!--注册操作框，流程3,支付宝扫一扫-->
      <div v-if="registerStep == 2" class="actionFrame">
        <div class="logo">
          <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
        </div>
        <div class="titleCtn" style="margin-top: 110px">
          <div class="title-2">请打开支付宝扫一扫</div>
        </div>
        <div class="contImgCtn">
          <img
                  :src="certificationImg"
                  height="300"
                  width="300"
                  style="margin-top: -32px;margin-left: -32px"
          />
          <!--二维码已过期蒙层-->
          <div v-if="timeOutMantle" class="contImgCtnMantle">
            <div class="text5-ctn">已过期</div>
            <div @click="clickRefresh" class="contImgCtnMantle-button">刷新</div>
          </div>
        </div>
        <div @click="backToChangeInput" class="text4-ctn">&lt; 返回重新输入</div>
        <!--底部文字-->
        <div class="text2-ctn" style="font-size: 14px">
          Copyright © 2023-2025 长光卫星技术股份有限公司
          <a
                  target="_blank"
                  href="/PrivacyPolicy"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 隐私政策
          </a>
          <a
                  target="_blank"
                  href="/ServiceAgreement"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 服务协议</a
          >
        </div>
        <!--错误提示-->
        <div v-if="showAlert" class="alertCtn">
          {{ alertTip }}
          <img
                  class="closeAlert"
                  @click="showAlert = false"
                  src="../assets/RegisterNew/关闭提示内容.png"
                  height="22"
                  width="22"
          />
        </div>
      </div>
        <!--注册操作框，流程4,认证成功或失败-->
      <div v-if="registerStep == 3" class="actionFrame">
        <div class="logo">
          <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
        </div>
        <!--如果认证不成功-->
        <div v-if="!certifySuccess" class="detailInformationCtn2">
          <img
                  style="margin-top: 38px; margin-left: 130px"
                  src="../assets/RegisterNew/认证失败.png"
                  height="312"
                  width="363"
          />
          <div
                  @click="registerStep = 1"
                  class="text4-ctn"
                  style="margin-top: 50px"
          >
            &lt; 返回重新输入
          </div>
        </div>
        <!--如果认证成功-->
        <div v-if="certifySuccess" class="detailInformationCtn2">
          <div class="text6-ctn" style="margin-top: 60px">
            <img
                    src="../assets/RegisterNew/认证成功.png"
                    height="44"
                    width="44"
            />
          </div>
          <div class="text6-ctn" style="margin-top: 30px; padding-left: 20px">
            您已完成实名认证
          </div>
          <!--立即完善注册-->
          <!-- <div
                  @click="registerStep = 4"
                  class="operateButton"
                  style="margin-top: 110px"
          >
            {{lastTime_success_show}}
          </div> -->
          <div
                  @click="$router.push('/')"
                  class="operateButton"
                  style="margin-top: 110px"
          >
          返回首页
          </div>
          <!--稍后完善-->
          <!--<div class="operateButton2" style="margin-top: 15px">稍后完善</div>-->
        </div>

        <!--底部文字-->
        <div class="text2-ctn" style="font-size: 14px">
          Copyright © 2023-2025 长光卫星技术股份有限公司
          <a
                  target="_blank"
                  href="/PrivacyPolicy"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 隐私政策
          </a>
          <a
                  target="_blank"
                  href="/ServiceAgreement"
                  @click.stop
                  style="text-decoration: none; color: #979797"
          >
            · 服务协议</a
          >
        </div>
        <!--错误提示-->
        <div v-if="showAlert" class="alertCtn">
          {{ alertTip }}
          <img
                  class="closeAlert"
                  @click="showAlert = false"
                  src="../assets/RegisterNew/关闭提示内容.png"
                  height="22"
                  width="22"
          />
        </div>
      </div>
        <!--注册操作框，流程5,完善注册信息-->
      <div v-if="registerStep == 4" class="actionFrame">
        <div class="logo">
          <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
        </div>
        <div class="titleCtn">
          <div class="title-1">第二步 完善实名信息</div>
        </div>
        <div class="text3-ctnRed">实名认证需完善个人信息</div>
        <div @click="whyIdentifyTip = true" class="text3-ctn" style="margin-top: 2px;">
          为什么要完善实名信息
          <img
                  src="../assets/RegisterNew/为什么-默认.png"
                  style="margin-bottom: -1px"
                  height="12"
                  width="12"
          />
          <div
                  v-if="whyIdentifyTip"
                  style="position: absolute; left: 163px; top: -38px"
          >
            <img
                    @click.stop="whyIdentifyTip = false"
                    src="../assets/RegisterNew/完善信息提示.png"
                    height="95"
                    width="321"
            />
            <img
                    @click.stop="whyIdentifyTip = false"
                    style="position: absolute; top: 5px; right: 5px"
                    src="../assets/RegisterNew/关闭提示内容.png"
                    height="16"
                    width="16"
            />
          </div>
        </div>
        <div class="detailInformationCtn">
          <!--手机号-->
          <!-- <div class="input-ctn" style="margin-top: 10px">
            <v-text-field
                    v-model="telephone"
                    label="手机号"
                    placeholder="请输入手机号"
                    outlined
                    readonly
                    disabled
            >
              <template v-slot:prepend-inner>
                <div
                        style="
                    width: 35px;
                    padding-top: 3px;
                    padding-bottom: 2px;
                    border-right: solid 1px rgba(0, 0, 0, 0.25);
                    color: rgba(0, 0, 0, 0.35);
                  "
                >
                  +86
                </div>
              </template>
            </v-text-field>
          </div> -->
          <!--邮箱-->
          <div class="input-ctn" style="margin-top: 25px">
            <v-text-field
                v-model="email"
                label="邮箱*"
                placeholder=" "
                outlined
                :rules="[rules.email,rules.notNull]"
            >
            </v-text-field>
          </div>
          <!--公司/组织-->
          <div class="input-ctn" style="margin-top: 25px">
            <v-text-field
                    v-model="companyName"
                    label="公司/组织*"
                    placeholder=" "
                    outlined
                    :rules="[rules.notNull]"
            >
            </v-text-field>
          </div>
          <!--关注区域-->
          <div class="input-ctn" style="margin-top: 25px">
            <div class="purposeArea" style="width: 250px">
              <v-select
                      label="中国"
                      v-model="purposeArea1"
                      placeholder="中国"
                      disabled
                      outlined
                      :rules="[rules.notNull]"
              ></v-select>
            </div>
            <div class="purposeArea" style="margin-left: 10px">
              <v-select
                      v-model="purposeArea2"
                      :items="areaList"
                      label="用户所在区域*"
                      placeholder=" "
                      :rules="[rules.notNull]"
                      outlined
              ></v-select>
            </div>
          </div>
          <div class="input-ctn" style="margin-top: 25px">
            <div class="purposeArea" style="width: 250px">
              <!--关注行业-->
              <v-select
                    v-model="focusIndustry"
                    :items="industryItems"
                    label="关注行业*"
                    placeholder=" "
                    outlined
                    :rules="[rules.notNull]"
            ></v-select>
            </div>
            <div class="purposeArea" style="margin-left: 10px">
              <!--从何渠道了解我们-->
              <v-select
                    v-model="liaojiequdao"
                    :items="liaojiequdaoItems"
                    label="从何渠道了解我们"
                    placeholder=" "
                    outlined
            ></v-select>
            </div>
          </div>
        </div>
        <div class="bottomInfo">
          <!--点击注册-->
          <div
                    @click="completeAndSubmit"
                    class="operateButton"
            >
              提交
          </div>
           <!--底部文字-->
          <div class="text-ctn" style="margin-top:20px">
            已有吉林一号账号？现在就去<span @click="$router.push('/Login')" style="color: #006699">登录</span>
          </div>
          <div class="text7-ctn" style="font-size: 14px">
            Copyright © 2023-2025 长光卫星技术股份有限公司
            <a
                    target="_blank"
                    href="/PrivacyPolicy"
                    @click.stop
                    style="text-decoration: none; color: #979797"
            >
              · 隐私政策
            </a>
            <a
                    target="_blank"
                    href="/ServiceAgreement"
                    @click.stop
                    style="text-decoration: none; color: #979797"
            >
              · 服务协议</a
            >
          </div>
        </div>
        <!--错误提示-->
        <div v-if="showAlert" class="alertCtn">
          {{ alertTip }}
          <img
                  class="closeAlert"
                  @click="showAlert = false"
                  src="../assets/RegisterNew/关闭提示内容.png"
                  height="22"
                  width="22"
          />
        </div>
      </div>
        <!--注册操作框，流程6,完成全部流程-->
      <div v-if="registerStep==5" class="actionFrame">
        <div class="logo">
          <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
        </div>

        <!--如果认证成功-->
        <div class="detailInformationCtn2">
          <div class="text6-ctn" style="margin-top: 60px">
            <img src="../assets/RegisterNew/认证成功.png" height="44" width="44"/>
          </div>
          <div class="text6-ctn" style="margin-top: 30px;padding-left: 0px">
            您已完成实名认证
          </div>
          <!--立即返回首页-->
          <div @click="$router.push('/')" class="operateButton" style="margin-top: 125px;">
            立即返回首页
          </div>
        </div>
        <!--底部文字-->
        <div class="text2-ctn" style="font-size: 14px">
          Copyright © 2023-2025 长光卫星技术股份有限公司
          <a
                  target="_blank"
                  href="/PrivacyPolicy"
                  @click.stop
                  style="text-decoration:none;color: #979797;"
          >
            · 隐私政策
          </a>
          <a
                  target="_blank"
                  href="/ServiceAgreement"
                  @click.stop
                  style="text-decoration:none;color: #979797;"
          >
            · 服务协议</a>

        </div>
        <!--错误提示-->
        <div v-if="showAlert" class="alertCtn">
          {{alertTip}}
          <img class="closeAlert" @click="showAlert=false;" src="../assets/RegisterNew/关闭提示内容.png" height="22"
               width="22"/>
        </div>
      </div>
      </span>
<!--            <div @click="certifySuccess=!certifySuccess" style="position:absolute;right:210px;bottom:80px;border: solid 1px #ff4040;color:#ffffff;">-->
<!--              认证状态-->
<!--            </div>-->
<!--            <div @click="registerStep++" style="position:absolute;right:210px;bottom:50px;border: solid 1px #ff4040;color:#ffffff;">-->
<!--              registerStep++-->
<!--            </div>-->
<!--            <div @click="registerStep&#45;&#45;" style="position:absolute;right:210px;bottom:20px;border: solid 1px #ff4040;color:#ffffff;">-->
<!--              registerStep&#45;&#45;-->
<!--            </div>-->
    </div>
  </body>
</template>

<script>
  import {rootUrl} from '@/globalConfig'

  export default {
  name: "Authentication",
  data() {
    return {
      lastTime_success_show:'立即完善实名',
      userId:'',
      timer:'',//循环定时器
      certificationId:'',
      certificationImg:'',
      ifShowPassword:false,
      liaojiequdao: "",
      shiyongchengdu: "",
      mainPurpose: "", //主要用途
      focusIndustry: "", //关注行业
      companyName: "", //公司或组织
      email:'',
      countryList: [],
      areaList: [],
      areaListTemp: [],
      purposeArea2: "", //关注子区域
      purposeArea1: "中国", //关注区域
      password2: "",
      password1: "",
      shiyongchengduItems: [
        "从未用过",
        "入门级使用",
        "中等程度使用",
        "专家级/重度使用",
      ],
      liaojiequdaoItems: [
        "公众号",
        "抖音",
        "其他自媒体平台",
        "行业新闻",
        "展会论坛",
        "商业合作",
        "口口相传"
      ],
      purposeItems: [
        "遥感影像解译与分析",
        "数据采集",
        "软件或服务开发",
        "评估商业机会",
        "科学研究",
        "单纯探索",
      ],
      industryItems: [
            "农业",
            "林业",
            "自然资源",
            "生态环保",
            "金融电力",
            "水利交通",
            "安全应急",
            "个人兴趣",
        ],
      certifySuccess: true, //是否验证成功
      timeOutMantle: false, //二维码过期
      certificationAllow: false, //是否可以实名认证
      checkIdentifyResult: false, //身份证格式是否正确
      registerAllow: false,
      checkPhoneResult: "", //手机号码验证是否通过，通过为true，否则为字符串
      realName: "",
      IDCard: "",
      whyIdentifyTip: false, //实名认证原因提示框
      registerStep: 1, //实名流程进行到的步骤，预计流程分为5步
      randomPic: 7, //1-7随机数，用于选择背景图片
      telephone: "", //手机号
      countDown: "获取验证码", //发送验证码，与再次发送倒计时
      canSendAgain: true, //可以发送验证码
      accessCode: "", //短信验证码
      read_checkbox: false, //已阅读并同意选择框
      alertTip: "请输入正确的手机号码",
      showAlert: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phone: (value) => {
          const pattern = /^[0-9]{11}$/;
          if (value) {
            return pattern.test(value) || "请填写正确的手机号码";
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (value) {
            return pattern.test(value) || "请填写正确的邮箱格式";
          } else {
            return true;
          }
        },
        passwordPattern: (value) => {
          const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
          if (value) {
            return (
              pattern.test(value) ||
              "请填写正确的密码格式，要求为8-20位大小写字母和数字的组合"
            );
          } else {
            return true;
          }
        },
        password2Pattern: (value) => {
          if (value != this.password1) {
            return "请保持前后密码一致";
          } else {
            return true;
          }
        },
        notNull: (value) => {
          if (value == "" || value == null) {
            return "此项不能为空";
          } else {
            return true;
          }
        },
      },
      returnUrl:'',//需要返回的上一个页面
      fromUrl:'',//需要返回的上一个页面，用于多系统联系，优先级高于returnUrl
      // authentication:0,
    };
  },
  methods: {
    getKey() {
      return localStorage.getItem("token");
    },
    setLocalStorageItem(key, value) {
      localStorage.setItem(key, value);
    },
    //获取用户信息
    getLoginInfo() {
      let that = this;
      this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            if (res.data.success) {
              this.print(res.data);
              this.$store.state.user.userId = res.data.data.account;
              this.$store.state.user.name = res.data.data.name;
              this.$store.state.user.vipLevel = res.data.data.vipLevel;
              this.setCookie("userId", res.data.data.account);
              this.setCookie(
                  "userInfo",
                  JSON.stringify({
                    phone: res.data.data.phone,
                    location: res.data.data.location,
                  })
              );
              this.$store.state.user.logined = true;
              let authentication = res.data.data.authentication
             
              this.$store.state.user.authentication=authentication;//是否实名认证，0是，1否
              this.setLocalStorageItem('authentication',authentication); //是否实名认证，0是，1否;为方便其他系统用
              this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
              this.telephone = res.data.data.phone;//赋值手机号
              if(authentication=='0'){
                this.alertTip='您已经是实名用户，无需再次实名'
                this.showAlert=true;
                setTimeout(() => {
                  this.alertTip=''
                  this.showAlert=false;
                  //优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
                  if(this.fromUrl){
                    window.open(this.fromUrl,"_self");
                    return;
                  }
                  else {
                    if (this.returnUrl !== "") {
                      this.$router.push(this.returnUrl);
                    } else {
                      this.$router.push("/");
                    }
                  }
                }, 1500);
              }
              if (res.data.data.endTime) {
                this.vip_endTime = res.data.data.endTime.split(" ")[0];
              }
            } else {
                this.$store.state.user.logined = false;
                setTimeout(() => {
                  this.$store.state.user.userId = "";
                  // this.setCookie('userId', "");
                  localStorage.setItem("userId", "");
                  //登录后返回实名认证页
                  this.returnUrl="/Authentication"
                  //优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
                  if(this.fromUrl){
                    window.open(this.fromUrl,"_self");
                    return;
                  }
                  else {
                    if (this.returnUrl !== "") {
                      this.$router.push(this.returnUrl);
                    } else {
                      this.$router.push("/");
                    }
                  }
                  this.alertTip="";
                  this.showAlert=false;
                }, 1000);

            }
          });
    },
    //识别屏幕缩放比例
    detectZoom(){
      var ratio = 0,
              screen = window.screen,
              ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      }
      else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      }
      else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio){
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    //点击支付宝扫一扫下的返回重新输入
    backToChangeInput(){
      clearInterval(this.timer);
      this.registerStep = 1;

    },
    //刷新二维码
    clickRefresh(){
      this.timeOutMantle=false;
      clearInterval(this.timer);
      this.clickCertification();

    },
    //查询实名认证是否通过
    inquiryCertificationResult(){
      let param = new FormData();
      param.append("orderId", this.certificationId);
      param.append("name", this.realName);
      param.append("phone", this.telephone);
      this.axios.post("/loginapi/AlipayIdentity/queryAlipayUserCertifyStatus", param).then((res) => {
        console.log(res);
        let resData = res.data;
        if(resData.success==true){
          clearInterval(this.timer);
          this.userId=resData.message;
          this.registerStep=3;
          this.certifySuccess=true;
          // let lastTime_success = 3;
          // let that = this;
          // let interval = setInterval(function () {
          //   if (lastTime_success > 1) {
          //     lastTime_success = lastTime_success - 1;
          //     that.lastTime_success_show="立即完善实名（"+lastTime_success+"s)"
          //   } else {
          //     that.registerStep = 4;
          //     clearInterval(interval);
          //   }
          // }, 1000);

        } else {
          //账号信息不完善
          if (resData.code == 50001) {
            if (this.timer != null) {
              clearInterval(this.timer);
            }
            alert(resData.message)
            // this.registerStep = 4;
            // this.certifySuccess = false;
          }
          if (resData.code == 50002) {
            if (this.timer != null) {
              clearInterval(this.timer);
            }
            alert(resData.message)
            // this.registerStep = 4;
            // this.certifySuccess = false;
          }
          //超时
          if (resData.code == 50003) {
            this.timeOutMantle = true;
            if (this.timer != null) {
              clearInterval(this.timer);
            }
          }
        }
      });
    },
    //点击实名认证
    clickCertification(){
      if(this.certificationAllow){
        let param = new FormData();
        param.append("userName", this.realName);
        param.append("userIdCard", this.IDCard);
        this.axios.post("/loginapi/AlipayIdentity/getAlipayCertifyQRCode", param).then((res) => {
          console.log(res);
          let resData = res.data;
          if(resData.success==true){
            this.registerStep=2;
            this.certificationImg=resData.data.QRCode;
            this.certificationId=resData.data.orderId;
            this.timer = setInterval(this.inquiryCertificationResult,2000);
          }
          else {
            alert('验证有误')
          }
        });
      }

    },
    //设置显示密码
    showPassword(){
      this.ifShowPassword=true;
    },
    //设置隐藏密码
    hidePassword(){
      this.ifShowPassword=false;
    },
    //带权限判断的跳转
    jumpWithPermission(type, path, fromUrl,event) {
              //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
              //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
              let loginUserId = localStorage.getItem("userId"); //是否已登录
              let authentication = localStorage.getItem("authentication"); //0:已实名；1：未实名
              if (type == "可游客") {
                  if (fromUrl) {
                      window.open(
                          rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                          "_self"
                      );
                  } else {
                      window.open(rootUrl + path, "_self");
                  }
              } else if (type == "仅登录") {
                  //已登录
                  if (loginUserId) {
                      if (fromUrl) {
                          window.open(
                              rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                              "_self"
                          );
                      } else {
                          window.open(rootUrl + path, "_self");
                      }
                  }
                  //未登录
                  else {
                      if (fromUrl) {
                          window.open(
                              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                              "_self"
                          );
                      } else {
                          window.open(rootUrl + "/Login", "_self");
                      }
                  }
              } else if (type == "仅实名") {
                  //已登录
                  if (loginUserId) {
                      //已实名
                      if (authentication == "0") {
                          if (fromUrl) {
                          window.open(
                              rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                              "_self"
                          );
                          } else {
                              window.open(rootUrl + path, "_self");
                          }
                      }
                      //未实名
                      else {
                          window.open(rootUrl + "/Authentication", "_self");
                      }
                  }
                  //未登录
                  else {
                      if (fromUrl) {
                          window.open(
                              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                              "_self"
                          );
                      } else {
                          window.open(rootUrl + "/Login", "_self");
                      }
                  }
              }
          },
    //完善信息，点击完成
    completeAndSubmit() {
      const pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$$/;
      const emailPattern=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.email.trim() == "" || this.email.trim() == null) {
        this.alertTip = "请填写邮箱";
        this.showAlert = true;
        return;
      }
      if(!emailPattern.test(this.email)){
        this.alertTip = "请填写正确格式的邮箱";
        this.showAlert = true;
        return;
      }
      if (this.companyName.trim() == "" || this.companyName.trim() == null) {
        this.alertTip = "企业/组织名不能为空";
        this.showAlert = true;
        return;
      }
      // if (this.mainPurpose == "" || this.mainPurpose == null) {
      //   this.alertTip = "主要用途不能为空";
      //   this.showAlert = true;
      //   return;
      // }
      if (this.focusIndustry == "" || this.focusIndustry == null) {
        this.alertTip = "关注行业不能为空";
        this.showAlert = true;
        return;
      }
      if (this.purposeArea2 == "" || this.purposeArea2 == null) {
        this.alertTip = "关注子区域不能为空";
        this.showAlert = true;
        return;
      }
      let submitData={
        // "name": this.realName,//名字，与account相同
        // "password": this.password1,//密码
        "phone":this.telephone,//手机号
        "email":this.email,
        "company": this.companyName,//公司
        "industry": this.focusIndustry,//关注行业
        "focusArea": this.purposeArea1,//关注地区
        "focusField": this.purposeArea2,//关注子地区
        // "mainPuprose": this.mainPurpose,//主要用途
        // "useDegree": this.shiyongchengdu,//对卫星遥感使用程度
        "learnChannel": this.liaojiequdao//从渠道了解
      }

      this.axios.post("/loginapi/completeUserInfoForRegister", submitData).then((res) => {
        console.log(res)
        if(res.data.success){
          this.registerStep=5;
          this.alertTip = "";
          this.showAlert = false;
          if(sessionStorage.getItem('authFrom')=='ygyypt'){
            this.jumpWithPermission('可游客', '/openPlatform/home', '/')
          }
          //5秒后返回进入页
          setTimeout(() => {
            //优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
            if(this.fromUrl){
              window.open(this.fromUrl,"_self");
              return;
            }
            else {
              if (this.returnUrl !== "") {
                this.$router.push(this.returnUrl);
              } else {
                this.$router.push("/");
              }
            }
          }, 2000);

        }
      else {
          this.alertTip = "信息添加出错,请重新输入";
          this.showAlert = true;
        }

      });
    },
    //判断是否可以实名认证
    ifCanIdentify: function () {
      this.checkIdentifyResult = this.checkIDCode(this.IDCard);
      console.log("checkIdentifyResult:", this.checkIdentifyResult);
      if (this.checkIdentifyResult == true && this.realName.length > 1) {
        this.certificationAllow = true;
        //取消错误提示
        this.alertTip = "";
        this.showAlert = false;
      }
      //未输入真实姓名
      else if (this.realName.length <= 1) {
        this.certificationAllow = false;
        this.alertTip = "请输入真实姓名";
        this.showAlert = true;
        return;
      }
      //身份证号码格式不正确
      else if (this.checkIdentifyResult != true) {
        this.certificationAllow = false;
        this.alertTip = this.checkIdentifyResult;
        this.showAlert = true;
        return;
      }
    },
    //判断身份证格式是否正确
    checkIDCode: function (IDCode) {
      let GAT=IDCode.slice(0,6)
      console.log(GAT)
      if(GAT=='810000'||GAT=='820000'||GAT=='830000'){
        return "身份证号码格式错误";
      }
      let IdentifyPattern = /(^[1-9][0-9]{14}$)|(^[1-9][0-9]{16}[0-9xX]$)/;
      if (IDCode) {
        return IdentifyPattern.test(IDCode) || "身份证号码格式错误";
      } else {
        return "身份证号码格式错误";
      }
    },
    //点击实名
    clickRegister: function () {
      if (this.registerAllow) {
        let param = new FormData();
        param.append("phone", this.telephone);
        param.append("prefix", "");
        param.append("verifyCode", this.accessCode);
        this.axios.post("/loginapi/checkCodeForRegister", param).then((res) => {
          console.log(res);
          let resData = res.data;
          if (resData.success == false) {
            this.alertTip = resData.message;
            this.showAlert = true;
          } else if (resData.success == true) {
            this.registerStep = 2;
          }
        });
      }
    },
    //判断是否可以实名
    ifCanRegister: function () {
      if (
        this.checkPhoneResult == true &&
        this.read_checkbox == true &&
        this.accessCode.length > 1
      ) {
        console.log("可以实名");
        this.registerAllow = true;
      } else {
        this.registerAllow = false;
      }
    },
    //验证手机格式
    phonePattern: function (phone) {
      const pattern = /^[0-9]{11}$/;
      if (phone) {
        return pattern.test(phone) || "请填写正确的手机号码";
      } else {
        return "请填写正确的手机号码";
      }
    },
    //点击获取验证码
    clickSendCode: function () {
      let checkResult = this.phonePattern(this.telephone);
      this.checkPhoneResult = checkResult;
      //如果手机号通过正则检验
      if (checkResult == true) {
        //取消电话号码格式错误提示
        this.alertTip = "";
        this.showAlert = false;
        //如果可以发送验证码
        if (this.canSendAgain) {
          //立即禁用按钮，防止重复点击
          this.canSendAgain=false;
          //调用发送验证码的函数
          this.sendCode();
        }
      } else {
        this.alertTip = checkResult;
        this.showAlert = true;
      }
    },
    //发送验证码函数
    sendCode: function () {
      let param = new FormData();
      param.append("phone", this.telephone);
      param.append("prefix", "");
      this.axios.post("/loginapi/sendCodeForRegister", param).then((res) => {
        console.log(res);
        let resData = res.data;
        if (resData.success == false) {
          //失败时恢复按钮状态，允许用户重试
          this.canSendAgain=true;
          this.alertTip = resData.message;
          this.showAlert = true;
        }else{
          this.sendAgainCountDown();
        }
      });
    },
    //发送倒计时
    sendAgainCountDown: function () {
      let t = 60;
      this.canSendAgain = false;
      let timer = setInterval(() => {
        this.countDown = "重新发送 (" + t + "s)";
        t--;
        if (t < 0) {
          this.canSendAgain = true;
          this.countDown = "获取验证码";
          clearInterval(timer);
        }
      }, 1000);
    },
  },
  mounted() {
    this.getLoginInfo();
    if(sessionStorage.getItem('authFrom')=='ygyypt'){
      this.telephone=sessionStorage.getItem('authPhone')
    }
    this.axios.get("/accessapi/searchService/Area/id=-1").then((res) => {
      let areaItems = res.data.data;
      this.print(areaItems);
      for (let i = 0; i < areaItems.length; i++) {
        this.areaListTemp.push(areaItems[i].areaName);
      }
      this.areaList = this.areaListTemp;
    });
    this.axios.get("/accessapi/searchService/countryList").then((res) => {
      let countryItems = res.data.data;
      let countryList = [];
      countryList.push("中国");
      for (let i = 0; i < countryItems.length; i++) {
        countryList.push(countryItems[i].countryName);
      }
      this.countryList = countryList;
    });
    //获取fromUrl
    let fromUrl=""
    //防止都小写
    if(this.$route.query.fromUrl){
      fromUrl=this.$route.query.fromUrl;
    }else if(this.$route.query.fromurl){
      fromUrl=this.$route.query.fromurl;
    }
    this.fromUrl=fromUrl;
    //获取returnUrl
    if (
        this.$route.query.returnUrl != "" &&
        this.$route.query.returnUrl != undefined
    ) {
      this.returnUrl = this.$route.query.returnUrl;
    }

    //屏幕适应问题
    let screenZoom=this.detectZoom() //屏幕放大倍数
    let screenWidth=window.screen.width
    let divFrame = document.getElementById("actionFrameId");
    if(screenWidth<2500){
      divFrame.setAttribute("style","zoom:"+(100-(screenZoom-100)/1.8).toFixed(2).toString()+"%");
    }
  },
  created() {
    this.randomPic = Math.floor(Math.random() * 7 + 1);
  },
  watch: {
    accessCode:{
      handler:function () {
        if(this.accessCode.length>5){
          this.ifCanRegister()
        }
      }
    },
    IDCard:{
      handler:function () {
        console.log(this.IDCard,typeof(this.IDCard))
        if(this.IDCard.length>15){
          this.ifCanRegister()
        }
      }
    }
  },
};
</script>

<style scoped>
.contImgCtnMantle-button {
  margin-top: 39px;
  margin-left: 73px;
  width: 96px;
  height: 44px;
  background: #006699;
  border-radius: 8px;
  line-height: 44px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.text6-ctn {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  text-align: center;
}
.text5-ctn {
  margin-top: 99px;
  width: 100%;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 22px;
  text-align: center;
}
.contImgCtnMantle {
  position: absolute;
  top: 0px;
  width: 242px;
  height: 242px;
  background: rgba(255, 255, 255, 0.75);
}
.contImgCtn {
  position: relative;
  margin-top: 36px;
  width: 242px;
  height: 242px;
  margin-left: 189px;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  margin-top: 38px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.65);
  background-color: rgba(143, 143, 143, 0.48);
}
.detailInformationCtn2 {
  position: absolute;
  top: 130px;
  left: 0px;
  width: 620px;
  height: 479px;
}
.detailInformationCtn {
  position: absolute;
  top: 230px;
  left: 0px;
  width: 620px;
  height: 350px;
}
.bottomInfo{
  position: absolute;
  top: 598px;
  left: 0px;
  width: 620px;
  height: 130px;
}
.text4-ctn {
  margin-top: 79px;
  margin-left: 65px;
  width: 200px;
  height: 17px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 17px;
  cursor: pointer;
}
.text3-ctn {
  position: relative;
  margin-left: 231px;
  margin-top: 15px;
  width: 158px;
  height: 24px;
  background: #f5f5f6;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.text3-ctnRed{
  position: relative;
  margin-left: 231px;
  margin-top: 10px;
  width: 158px;
  height: 24px;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: red;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.text7-ctn {
  margin-left: 64px;
  margin-top: 10px;
  margin-bottom: 50px;
  width: 499px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text2-ctn {
  position: absolute;
  bottom: 33px;
  left: 65px;
  width: 499px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text-ctn {
  margin-left: 62px;
  width: 500px;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.operateButton2 {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  border: 1px solid #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.operateButton {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  background: #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.operateButton_disabled {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.getAccessCode {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.getAccessCode-disabled {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  cursor: pointer;
}
.purposeArea {
  float: left;
  width: 240px;
  height: 60px;
}
.input-ctn {
  width: 500px;
  height: 60px;
  margin-left: 60px;
}
.title-1 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  border-bottom: 3px solid #006699;
}
.title-2 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
}
.titleCtn {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 35px;
  margin-top: 85px;
}
.logo {
  position: relative;
  top: 58px;
  left: 174px;
  width: 272px;
  height: 44px;
  text-align: center;
  padding-right: 15px;
  font-size: 30px;
}
.closeAlert {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.alertCtn {
  position: absolute;
  top: -94px;
  left: 0px;
  width: 620px;
  height: 54px;
  line-height: 54px;
  background: #ff4040;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
.actionFrame {
  position: absolute;
  top: calc(50% - 384px);
  left: 50%;
  margin-left: -310px;
  width: 620px;
  height: 768px;
  background: #ffffff;
  border-radius: 16px;
}
</style>
